import axios from "@/plugins/axios";

// initial state
const state = () => ({
  contacts: [],
  filteredContacts: [],
  selectedContacts: [],
  importedContacts: [],
  importStatus: {},
  inviteStatus: {},
  templates: [],
  template: "",
  currentTemplateService: "",
  filterOptions: [],
  listFilter: "",
  loading: true,
});

const getters = {
  getContacts: (state) => {
    return state.contacts;
  },
  getFilteredContacts: (state) => {
    return state.filteredContacts;
  },
  isContactSelected: (state) => (contactId) => {
    return state.selectedContacts.indexOf(contactId) !== -1;
  },
  contactsIsIndeterminate(state) {
    return (
      state.selectedContacts.length > 0 &&
      state.selectedContacts.length !== state.filteredContacts.length
    );
  },
  contactsSelected(state) {
    return state.selectedContacts.length === state.filteredContacts.length;
  },
  isLoading: (state) => {
    return state.loading;
  },
  getSelectedContacts(state) {
    return state.selectedContacts;
  },
  getImportStatus(state) {
    return state.importStatus;
  },
  getInviteStatus(state) {
    return state.inviteStatus;
  },
  getFilterOptions(state) {
    return state.filterOptions;
  },
  getSelectedCount(state) {
    return state.selectedContacts.length;
  },
  getTemplateList(state) {
    return state.templates;
  },
  getTemplate(state) {
    return state.template;
  },
  getCurrentTemplate(state) {
    return state.templates.find((t) => t.service === state.currentTemplateService);
  },
};

const actions = {
  async fetchContacts({ commit, state, dispatch }) {
    commit("setIsLoading", true);
    try {
      let response = await axios.get("/api/rest/report/contacts/list");
      commit("setIsLoading", false);
      commit("clearSelectedContacts");
      commit("setContacts", response.data.list);
      commit("filterContacts", state.listFilter);
      let options = [];
      response.data.filters.map((o) => {
        options.push({
          value: o,
          text: o,
        });
      });
      commit("setListFilters", options);
    } catch (err) {
      console.log(err.response);
    }
  },
  async importContacts({ commit, state, dispatch }, formData) {
    try {
      const response = await axios.post("/api/rest/report/contacts/list/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      commit("setImportStatus", response.data.results);
      dispatch("fetchContacts");
    } catch (err) {
      console.log(err.response.data);
    }
  },
  async removeContact({ commit, state, dispatch }, contact) {
    try {
      await axios.delete(`/api/rest/admin/companyContacts/${contact.id}`);
      commit("addToast", {
        message: "Contact removed successfully",
        title: "Success",
        variant: "success",
      });
      dispatch("fetchContacts");
    } catch (err) {
      commit("addErrorToast", {
        errors: err.response.data.errors,
      });
    }
  },
  async fetchTemplateList({ commit }) {
    try {
      const res = await axios.get(`/api/rest/report/contacts/templateUrls`);
      commit("setTemplateList", res.data);
    } catch (err) {
      console.log(err.response.data);
    }
  },
  async fetchTemplate({ commit, state }, service) {
    try {
      const res = await axios.get(`/api/rest/report/contacts/email/preview/${service}`);
      commit("setTemplateService", service);
      commit("setTemplate", res.data);
    } catch (err) {
      console.log(err.response.data);
    }
  },
  selectAllContacts({ commit, state }) {
    commit("selectContacts", state.filteredContacts);
  },
  removeAllContacts({ commit, state }) {
    commit("removeSelections", state.filteredContacts);
  },
  async sendInvitations({ commit, state, dispatch }) {
    let formData = {};
    formData.ids = state.selectedContacts;

    try {
      const template = state.templates.find((t) => t.service === state.currentTemplateService);
      const response = await axios.post(
        `/api/rest/report/contacts/invite/send/${template.service}`,
        formData
      );
      commit("setTemplateService", "");
      commit("setInviteStatus", response.data);
      commit("filterContacts", "");
      dispatch("fetchContacts");
    } catch (err) {
      console.log(err);
    }
  },
};

const mutations = {
  setContacts(state, contacts) {
    state.contacts = contacts;
  },
  filterContacts(state, filter) {
    state.listFilter = filter;
    if (state.listFilter !== "") {
      state.filteredContacts = state.contacts.filter(
        (contact) => contact.list === state.listFilter
      );
    } else {
      state.filteredContacts = state.contacts;
    }
  },
  removeContact(state, contact) {
    state.contacts.filter((c) => c.id !== contact.id);
  },
  clearSelectedContacts(state) {
    state.selectedContacts = [];
  },
  setSelectable(state, selectable) {
    state.selectable = selectable;
  },
  selectContacts(state, contacts) {
    contacts.map((contact) => {
      if (state.selectedContacts.indexOf(contact.id) === -1) {
        state.selectedContacts.push(contact.id);
      }
    });
  },
  removeSelections(state, contacts) {
    let updatedContacts = state.selectedContacts;
    contacts.map((contact) => {
      updatedContacts = updatedContacts.filter((c) => c !== contact.id);
    });
    state.selectedContacts = updatedContacts;
  },
  toggleSelections(state, contacts) {
    let updatedContacts = state.selectedContacts;
    contacts.map((contact) => {
      if (updatedContacts.indexOf(contact.id) === -1) {
        updatedContacts.push(contact.id);
      } else {
        updatedContacts = updatedContacts.filter((c) => c !== contact.id);
      }
    });
    state.selectedContacts = updatedContacts;
  },
  setIsLoading(state, loadState) {
    state.loading = loadState;
  },
  setImportStatus(state, status) {
    state.importStatus = status;
  },
  setInviteStatus(state, status) {
    state.inviteStatus = status;
  },
  setListFilters(state, filters) {
    state.filterOptions = filters;
  },
  setTemplateList(state, templates) {
    state.templates = templates;
  },
  setTemplate(state, template) {
    state.template = template;
  },
  setTemplateService(state, service) {
    state.currentTemplateService = service;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
